import { createSlice, PayloadAction, configureStore } from '@reduxjs/toolkit'

import { Stream } from '../types'
import FashionPhoto from '../images/fashion-1.jpg';
import Fashion2Photo from '../images/fashion-2.jpg';
import Fashion3Photo from '../images/fashion-3.jpg';
import Fashion4Photo from '../images/fashion-4.jpg';
import Fashion5Photo from '../images/fashion-5.jpg';
import Fashion6Photo from '../images/fashion-6.jpg';
import Fashion7Photo from '../images/fashion-7.jpg';


const initialState: Stream[] = [{
    title: 'Healthy Morning',
    photo: FashionPhoto,
    description:'Summer vibes - a sale stream about my new summer fashion clothesSummer vibes - a sale stream about my new summer fashion clothesSummer vibes - a sale stream about my new summer fashion clothesSummer vibes - a sale stream about my new summer fashion clothesSummer vibes - a sale stream about my new summer fashion clothesSummer vibes - a sale stream about my new summer fashion clothesSummer vibes - a sale stream about my new summer fashion clothesSummer vibes - a sale stream about my new summer fashion clothesSummer vibes - a sale stream about my new summer fashion clothes',
    status: 'live',
    author: 'Mathy99',
    participants: 0,
    id: 3,
},
{
    title: '2020Loading Collection',
    photo: Fashion2Photo,
    description:'2020Loading all published albums ',
    status: 'planned',
    author: 'BXL515',
    participants: 0,
    id: 4
},
{
    title: 'My Donuts Collection ',
    photo: Fashion3Photo,
    description:'My favourite is chockolate donut',
    status: 'planned',
    author: 'DonutLover',
    participants: 0,
    id: 5
},
{
    title: 'New Glasses Collection 2020',
    photo: Fashion4Photo,
    description:'See our newest glasses collection!',
    status: 'live',
    author: 'BryLove',
    participants: 0,
    id: 6
},
{
    title: 'New Perfumes',
    photo: Fashion5Photo,
    description:'No description',
    status: 'planned',
    author: 'Perfurify',
    participants: 0,
    id: 7
},
{
    title: 'Jeaninne',
    photo: Fashion6Photo,
    description:'Mon nouveau album - Jeannine',
    status: 'live',
    author: 'Lomepal',
    participants: 0,
    id: 8
},
{
    title: 'Butter',
    photo: Fashion7Photo,
    description:'I show my butter collection',
    status: 'planned',
    author: 'Ireallylikebutter',
    participants: 0,
    id: 9
},];

const initialStateActualStream: Stream = {
    title: 'Butter',
    photo: Fashion7Photo,
    description:'I show my butter collection',
    status: 'planned',
    author: 'Ireallylikebutter',
    participants: 0,
    id: 9
}


const streamsSlice = createSlice( {
    name: 'streams',
    initialState: initialState,
    reducers: {
        set: (state, {payload}: PayloadAction<Stream>) => {
            // mutable thanks to redux-toolkit
            state.push(payload);
        },
        remove: (state, {payload}: PayloadAction<{ id: number }>) => {
            const index = state.findIndex( stream => stream.id === payload.id);
            if( index !== -1 ) state.splice(index, 1);
        }
    }
} )

const actualStreamSlice = createSlice( {
    name: 'actualStream',
    initialState: initialStateActualStream,
    reducers: {
        set: ( state, { payload }: PayloadAction<Stream>) => {
            return { ...state, ...payload}
        }
    }
} )


////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////


interface Database {
    streams: Stream[];
}

const initialStateDB: Stream[]  = [
    {
        title: 'Butter',
        photo: Fashion7Photo,
        description:'I show my butter collection',
        status: 'planned',
        author: 'Ireallylikebutter',
        participants: 0,
        id: 9
    }
]

const databaseSlice = createSlice( {
    name: 'database',
    initialState: initialStateDB,
    reducers: {
        add: (state, {payload}: PayloadAction<Stream>) => {
            state.push(payload);
        }
    }
} )



////////////////////////////////////////////////////
////////////////////////////////////////////////////


const reducers = {
    streams: streamsSlice.reducer,
    actualStream: actualStreamSlice.reducer,
    databaseStreams: databaseSlice.reducer
}

export default configureStore( {
    reducer: reducers,
} )

export const {
    set: setStreamActionCreator, remove: removeStreamActionCreator
} = streamsSlice.actions;

export const {
    set: setActualStreamActionCreator
} = actualStreamSlice.actions;

export const{
    add: addDatabaseStreamActionCreator
} = databaseSlice.actions